module.exports = __webpack_public_path__ + "assets/2_2_2_IFOK_WIM_INTEROPERABILITY_REGULATION_platform_for_svg_je.8caaa61c.svg";